module.exports = __webpack_public_path__ + "static/img/31-2.2697982.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/31-2.jpg
// module id = s17z
// module chunks = 0